export default __webpack_public_path__ + "static/videoSection-be043024a98e5246346c54568015936d.svg";